import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { BsChevronDown, BsChevronUp, BsPencilFill, BsEye, BsEyeSlash, BsJournalText } from "react-icons/bs";
import { CiCalculator1 } from "react-icons/ci";
import { VscReferences } from "react-icons/vsc";
import { BsThreeDotsVertical, BsExclamationTriangle } from "react-icons/bs";
import Question from "./MathQuestion";
import axios from "axios";
import Timer from "./Timer";
import { motion } from "framer-motion";
import { UserContext } from "../../context/UserContext";
import { BASELINE } from "../../util";
import Review from "./Review";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import DirectionModal from './DirectionModal';
import ReferenceSheet from './ReferenceSheet';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { useStopwatch } from "react-timer-hook";
import { FaKey } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { BiSolidDirections } from "react-icons/bi";

const PresetSAT = ({ free, freesat }) => {
  const { id: initialId } = useParams();
  const [id, setId] = useState(initialId);

  useEffect(() => {
    if (freesat) {
      setId(freesat);
    }
  }, [freesat]);

  const [questionsarr, setquestionsarr] = useState([]);
  const [section, setsection] = useState(4);

  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [showCalculator, setShowCalculator] = useState(false);
  const [questionOverViewOpen, setQuestionOverviewOpen] = useState(false);
  const [showReference] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [bookmarkedQuestions, setBookMarkedQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [Error, setError] = useState('');
  const [showDirectionModal, setShowDirectionModal] = useState(false);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [showDirectionModalRef, setShowDirectionRefModal] = useState(false);
  const [sat, setsat] = useState("");
  const [answers, setanswers] = useState([]);
  const [breaks, setbreaks] = useState(true);

  const [test_id, settest_id] = useState(uuidv4());
  const [showOptions, setShowOptions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [context, setContext] = useState('');

  const timeSpentRef = useRef({});      // { [questionId]: seconds } — accumulated per question
  const questionEntryRef = useRef(null); // { id, entryTime } — when user entered current question
  const [userResponses, setUserResponses] = useState({});
  const [loadcurr, setloadcurr] = useState(0);
  const [qanswers, setqanswers] = useState([]);
  const [qbookmarks, setqbookmarks] = useState([]);
  const [qarr, setqarr] = useState([]);
  const location = useLocation();
  const responseData = location.state?.data;
  // Initialize auto=false when there is a saved test to restore, so the section
  // effect doesn't call fetchMathData() before the restore flow completes.
  const [auto, setauto] = useState(() => {
    if (free) return true;
    return localStorage.getItem('currentTest') === null;
  });
  const [timeLeft, setTimeLeft] = useState(null); // Countdown timer
  const { start, reset } = useStopwatch({ autoStart: false }); // Use stopwatch for untimed mode
  const [showanswer, setshowanswer] = useState(false);
  const [timerHidden, setTimerHidden] = useState(false);
  const [notes, setNotes] = useState({});
  const [showNotePanel, setShowNotePanel] = useState(false);
  const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);

  const [highlightMode, setHighlightMode] = useState(() => {
    try {
      const c = document.cookie.split('; ').find(r => r.startsWith('highlightMode='));
      return c?.split('=')[1] === 'true';
    } catch { return false; }
  });

  const toggleHighlightMode = useCallback(() => {
    const next = !highlightMode;
    setHighlightMode(next);
    document.cookie = `highlightMode=${next}; path=/; max-age=86400`;
  }, [highlightMode]);

  const applyHighlightByText = useCallback((container, text, questionId) => {
    if (!text || !container) return;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.tagName === 'MARK') continue;
      const idx = node.textContent.indexOf(text);
      if (idx === -1) continue;
      const range = document.createRange();
      range.setStart(node, idx);
      range.setEnd(node, idx + text.length);
      const mark = document.createElement('mark');
      mark.style.cssText = 'background-color:#fef08a;border-radius:3px;cursor:pointer;padding:0 1px;';
      mark.title = 'Click to remove highlight';
      mark.onclick = (e) => {
        const parent = mark.parentNode;
        while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
        parent.removeChild(mark);
        if (highlightsRef.current[questionId]) {
          const i = highlightsRef.current[questionId].indexOf(text);
          if (i !== -1) highlightsRef.current[questionId].splice(i, 1);
        }
        e.stopPropagation();
      };
      try { range.surroundContents(mark); }
      catch { const frag = range.extractContents(); mark.appendChild(frag); range.insertNode(mark); }
      break;
    }
  }, []);

  const handleMouseUp = useCallback(() => {
    if (!highlightMode) return;
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;
    const selectedText = selection.toString().trim();
    if (!selectedText) return;
    const range = selection.getRangeAt(0);
    const questionId = currentQuestion?.questionIds;
    const mark = document.createElement('mark');
    mark.style.cssText = 'background-color:#fef08a;border-radius:3px;cursor:pointer;padding:0 1px;';
    mark.title = 'Click to remove highlight';
    mark.onclick = (e) => {
      const parent = mark.parentNode;
      while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
      parent.removeChild(mark);
      if (questionId && highlightsRef.current[questionId]) {
        const i = highlightsRef.current[questionId].indexOf(selectedText);
        if (i !== -1) highlightsRef.current[questionId].splice(i, 1);
      }
      e.stopPropagation();
    };
    try {
      range.surroundContents(mark);
    } catch {
      const frag = range.extractContents();
      mark.appendChild(frag);
      range.insertNode(mark);
    }
    selection.removeAllRanges();
    if (questionId) {
      if (!highlightsRef.current[questionId]) highlightsRef.current[questionId] = [];
      highlightsRef.current[questionId].push(selectedText);
    }
  }, [highlightMode, currentQuestion]);

  const [constraints, setConstraints] = useState({ top: 0, left: 0, right: 0, bottom: 0 });
  const quizContentRef = useRef();
  const constraintsRef = useRef(null);
  const highlightsRef = useRef({});
  const prevQuestionIdRef = useRef(null);

  useEffect(() => {
    // 화면 크기에 맞춰 값 계산 (예: 박스 크기가 600x400이라고 가정)
    const calcConstraints = () => {
      const boxWidth = 600;
      const boxHeight = 400;
      setConstraints({
        top: 0,
        left: 0,
        right: window.innerWidth - boxWidth,   // 드래그 박스가 창 우측 바깥으로 나가지 않도록
        bottom: window.innerHeight - boxHeight // 드래그 박스가 창 하단 바깥으로 나가지 않도록
      });
    };

    // 초기 계산 + 윈도우 리사이즈 시 재계산
    calcConstraints();
    window.addEventListener("resize", calcConstraints);

    return () => window.removeEventListener("resize", calcConstraints);
  }, []);
  const displayMinutes = timeLeft != null ? Math.floor(timeLeft / 60) : 0;
  const displaySeconds = timeLeft != null ? timeLeft % 60 : 0;

  const satScoringTable = [
    { numcor: 1, Eng: [200, 200], math: [200, 200] },
    { numcor: 2, Eng: [200, 200], math: [200, 200] },
    { numcor: 3, Eng: [220, 220], math: [210, 210] },
    { numcor: 4, Eng: [240, 240], math: [220, 220] },
    { numcor: 5, Eng: [240, 260], math: [230, 230] },
    { numcor: 6, Eng: [260, 280], math: [240, 240] },
    { numcor: 7, Eng: [270, 290], math: [250, 250] },
    { numcor: 8, Eng: [280, 300], math: [260, 300] },
    { numcor: 9, Eng: [290, 300], math: [270, 310] },
    { numcor: 10, Eng: [300, 310], math: [280, 310] },
    { numcor: 11, Eng: [300, 340], math: [290, 330] },
    { numcor: 12, Eng: [310, 360], math: [300, 350] },
    { numcor: 13, Eng: [310, 380], math: [310, 360] },
    { numcor: 14, Eng: [320, 400], math: [320, 380] },
    { numcor: 15, Eng: [320, 400], math: [330, 400] },
    { numcor: 16, Eng: [330, 410], math: [340, 420] },
    { numcor: 17, Eng: [330, 420], math: [350, 430] },
    { numcor: 18, Eng: [340, 430], math: [360, 540] },
    { numcor: 19, Eng: [350, 440], math: [370, 550] },
    { numcor: 20, Eng: [360, 450], math: [380, 560] },
    { numcor: 21, Eng: [370, 460], math: [390, 570] },
    { numcor: 22, Eng: [380, 490], math: [400, 580] },
    { numcor: 23, Eng: [390, 500], math: [410, 590] },
    { numcor: 24, Eng: [400, 510], math: [420, 600] },
    { numcor: 25, Eng: [410, 520], math: [430, 610] },
    { numcor: 26, Eng: [420, 530], math: [440, 620] },
    { numcor: 27, Eng: [430, 540], math: [450, 630] },
    { numcor: 28, Eng: [440, 550], math: [460, 640] },
    { numcor: 29, Eng: [450, 560], math: [470, 650] },
    { numcor: 30, Eng: [460, 570], math: [480, 670] },
    { numcor: 31, Eng: [470, 580], math: [490, 680] },
    { numcor: 32, Eng: [480, 590], math: [500, 690] },
    { numcor: 33, Eng: [490, 600], math: [510, 700] },
    { numcor: 34, Eng: [500, 610], math: [600, 710] },
    { numcor: 35, Eng: [510, 620], math: [600, 720] },
    { numcor: 36, Eng: [520, 630], math: [600, 730] },
    { numcor: 37, Eng: [530, 640], math: [600, 740] },
    { numcor: 38, Eng: [540, 650], math: [600, 750] },
    { numcor: 39, Eng: [550, 660], math: [600, 760] },
    { numcor: 40, Eng: [560, 670], math: [600, 770] },
    { numcor: 41, Eng: [570, 680], math: [600, 780] },
    { numcor: 42, Eng: [580, 690], math: [600, 790] },
    { numcor: 43, Eng: [590, 700], math: [600, 790] },
    { numcor: 44, Eng: [600, 710], math: [600, 800] },
    { numcor: 45, Eng: [600, 720], math: [800, 800] },
    { numcor: 46, Eng: [600, 730], math: [800, 800] },
    { numcor: 47, Eng: [600, 740], math: [800, 800] },
    { numcor: 48, Eng: [600, 750], math: [800, 800] },
    { numcor: 49, Eng: [600, 760], math: [800, 800] },
    { numcor: 50, Eng: [600, 770], math: [800, 800] },
    { numcor: 51, Eng: [600, 780], math: [800, 800] },
    { numcor: 52, Eng: [600, 790], math: [800, 800] },
    { numcor: 53, Eng: [600, 790], math: [800, 800] },
    { numcor: 54, Eng: [600, 800], math: [800, 800] },
  ];

  const handleSubmit2 = () => {
    var type;
    if (id.startsWith('p89_')) {
      type = 'SAT89';
    } else if (id.startsWith('p10_')) {
      type = 'SAT10';
    } else {
      type = 'SAT';
    }
    const questionId = currentQuestion.questionIds;
    const reportFrom = user.first_name + " " + user.last_name;

    // Do something with questionId, reportFrom, and context

    var data = {
      questionId: questionId,
      name: reportFrom,
      context: context,
      type: type
    }

    axios.post(BASELINE + 'questions/report/note', [data])
      .then(response => {
        alert('Report submitted successfully!');
      })
      .catch(error => {
        console.error(error);
      });

    setContext('');
    setShowModal(false);
  };

  const handleContextChange = (event) => {
    setContext(event.target.value);
  };

  const handleReportClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = () => {
    // Clear the context and close the modal
    setContext('');
    setShowModal(false);
  };

  useEffect(() => {
    if (!free) { // Assuming `free` is a boolean that if true, should not run this effect.
      const localStorageData = localStorage.getItem('currentTest');
      if (localStorageData) {
        setauto(false);
        settest_id(localStorageData);

        axios.get(BASELINE + 'getautosavebytid', { params: { tid: localStorageData } })
          .then(async (response) => { // Make sure to mark this function as async
            const savedData = response.data.data[0];
            if (savedData) {
              try {
                const jsonsetting = JSON.parse(savedData.Setting);
                const jsondata = JSON.parse(savedData.test_data);
                setsection(jsonsetting.section);
                if (jsonsetting.breaks === true) {
                  setTimeLeft(jsonsetting.timeLeft);
                  setbreaks(true);
                  setLoadingQuestions(true);
                  // Restore answers from completed sections so they aren't lost
                  setanswers(jsondata.answers || []);
                  // Remove early so the break-end flow doesn't re-enter restore
                  localStorage.removeItem('currentTest');
                } else {
                  if (jsonsetting.section === 4) {
                    setsat("English");

                  } else if (jsonsetting.section === 31 || jsonsetting.section === 32) {
                    setsat("English");

                  } else if (jsonsetting.section === 2) {
                    setsat("Math");

                  } else {
                    setsat("Math");
                  }
                  try {
                    const res = await axios.get(BASELINE + "sat/preset", { params: { satNumber: id } });
                    const stages = {
                      4: "stage1",
                      31: "stage21",
                      32: "stage22",
                      2: "stage3",
                      11: "stage41",
                      12: "stage42"
                    };
                    const stageKey = stages[jsonsetting.section];
                    if (stageKey) {
                      setquestionsarr(res.data.preset[stageKey]);
                      setqarr(res.data.preset[stageKey]);
                    }
                  } catch (err) {
                    toast.error('Something went wrong. Please try again.');
                  }


                  setqanswers(jsondata.qanswers);
                  setqbookmarks(jsondata.qbookmarks);
                  setanswers(jsondata.answers);
                  setTimeLeft(jsonsetting.timeLeft);
                  timeSpentRef.current = jsonsetting.timeperq || {};

                  const currentQuestionIndex = jsondata.questions.findIndex(q => q === savedData.questionIds);
                  setloadcurr(currentQuestionIndex);

                  // Remove localStorage before enabling auto so that if any effect
                  // re-checks localStorage it won't re-enter the restore path.
                  localStorage.removeItem('currentTest');
                  setTimeout(() => {
                    setauto(true);
                  }, 500);
                }
              } catch (parseError) {
                console.error("Error parsing autosave data:", parseError);
                toast.error('Failed to load saved test data. Starting a new test.');
                localStorage.removeItem('currentTest');
              }
            }
          })
          .catch(error => {
            console.error("Error fetching autosave data:", error);
            toast.error('Failed to load saved test data. Please try again.');
          });
      }
    }
  }, []); // Ensure dependencies are correctly listed

  const autosaveData = async () => {
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 19).replace('T', ' ');

    const qanswers = questions.map(question => question.selectedOption);
    const qbookmarks = questions.map(question => question.bookMarked);
    const qids = questions.map(question => question.questionIds);

    var name;
    if (id?.startsWith('p89_')) {
      name = "Digital SAT 8/9"
    }
    else if (id?.startsWith('p10_')) {
      name = "Digital NMSQT"
    }
    else {
      name = "Digital SAT " + id
    }

    const data = {
      id: id,
      user_id: user.u_id,
      section: section,
      questions: qids,
      questionIds: currentQuestion?.questionIds || null,
      timeLeft: timeLeft,
      answers: answers,
      qanswers: qanswers,
      qbookmarks: qbookmarks,
      test_id: test_id,
      date: formattedDate,
      timeperq: timeSpentRef.current,
      type: 'TEST',
      name: name,
      breaks: breaks
    };

    try {
      await axios.post(BASELINE + "autosave", { params: { data: JSON.stringify(data) } });
    } catch (err) {
      toast.error(err.message);
      setError(err.message);
    }
  };

  // Accumulate time spent on each question using refs — no re-render overhead
  useEffect(() => {
    const now = Date.now();
    const prev = questionEntryRef.current;

    // Flush time for the question we're leaving
    if (prev) {
      const elapsed = (now - prev.entryTime) / 1000;
      timeSpentRef.current[prev.id] = (timeSpentRef.current[prev.id] || 0) + elapsed;
    }

    // Start tracking the question we're entering
    if (currentQuestion) {
      questionEntryRef.current = { id: currentQuestion.questionIds, entryTime: now };
    } else {
      questionEntryRef.current = null;
    }
  }, [currentQuestion]);

  // Autosave whenever question or key state changes
  useEffect(() => {
    const localStorageData = localStorage.getItem('currentTest');
    if (!localStorageData) {
      if (free || !currentQuestion) return;
      if (!responseData) {
        autosaveData();
      }
    }
  }, [currentQuestion, user, section, questions, answers, id, test_id, breaks]);

  const fetchMathData = async () => {
    setbreaks(false);
    setLoadingQuestions(true);
    setquestionsarr([]);

    if (section === 4) {
      setTimeLeft(1925); //1925
      setsat("English");

    } else if (section === 31 || section === 32) {
      setTimeLeft(1925); //1925
      setsat("English");

    } else if (section === 2) {
      setTimeLeft(2100); //2100
      setsat("Math");

    } else {
      setTimeLeft(2100); //2100
      setsat("Math");
    }

    if (free !== true) {
      if (responseData) {
        if (section === 4) {
          setquestionsarr(responseData.result.stage1)
        }
        else if (section === 31) {
          setquestionsarr(responseData.result.stage21)
        }
        else if (section === 32) {
          setquestionsarr(responseData.result.stage22)
        }
        else if (section === 2) {
          setquestionsarr(responseData.result.stage3)
        }
        else if (section === 11) {
          setquestionsarr(responseData.result.stage41)
        }
        else if (section === 12) {
          setquestionsarr(responseData.result.stage42)
        }
      }
      else {
        try {
          let res = await axios.get(BASELINE + "sat/preset", { params: { satNumber: id } });
          if (section === 4) {
            setquestionsarr(res.data.preset["stage1"])
          }
          else if (section === 31) {
            setquestionsarr(res.data.preset["stage21"])
          }
          else if (section === 32) {
            setquestionsarr(res.data.preset["stage22"])
          }
          else if (section === 2) {
            setquestionsarr(res.data.preset["stage3"])
          }
          else if (section === 11) {
            setquestionsarr(res.data.preset["stage41"])
          }
          else if (section === 12) {
            setquestionsarr(res.data.preset["stage42"])
          }
        } catch (err) {
          toast.error('Something went wrong. Please try again.');
        }
      }
    } else {
      try {
        let res = await axios.get(BASELINE + "sat/preset", { params: { satNumber: 1 } });
        if (section === 4) {
          setquestionsarr(res.data.preset["stage1"])
        }
        else if (section === 31) {
          setquestionsarr(res.data.preset["stage21"])
        }
        else if (section === 32) {
          setquestionsarr(res.data.preset["stage22"])
        }
        else if (section === 2) {
          setquestionsarr(res.data.preset["stage3"])
        }
        else if (section === 11) {
          setquestionsarr(res.data.preset["stage41"])
        }
        else if (section === 12) {
          setquestionsarr(res.data.preset["stage42"])
        }
      } catch (err) {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  useEffect(() => {
    if (auto === true) {
      if (breaks === false && (section === 2)) {
        setTimeLeft(600);
        setLoadingQuestions(true);
        setbreaks(true);
      } else {
        fetchMathData();
      }
    }

    const interval = setInterval(() => {
      // Guard against null so we don't accidentally trigger timeLeft===0 before
      // the saved value is restored (null > 0 is false, so without this guard
      // null would snap to 0 and fire a spurious "Time's up" alert).
      setTimeLeft((prevTime) => (prevTime !== null && prevTime > 0 ? prevTime - 1 : prevTime));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [section]);

  useEffect(() => {
    if (timeLeft === 0) {
      if (breaks === false) {
        toast.error("Time's up!");
        handleSubmit();
      } else {
        // Break countdown finished — load next section
        fetchMathData();
        setauto(true);
      }
    }

    if (timeLeft === -1) {
      // User clicked "Resume" early — load next section immediately
      fetchMathData();
      setauto(true);
    }
  }, [timeLeft]);

  useEffect(() => {
    if (questionsarr.length > 0 && auto === true) {
      getQuestions();
    }
  }, [questionsarr, auto]);

  useEffect(() => {
    var elt = document.getElementById('calculator');
    var calculator = window.Desmos?.GraphingCalculator(elt, {
      graphpaper: true,
      keypad: true
    });
    return () => {
      calculator?.destroy();
    }
  }, [showCalculator]);

  useEffect(() => {
    if (questions.length > 0 && currentQuestion) {
      let q = questions.find((ques => ques?.questionIds === currentQuestion?.questionIds));
      setCurrentQuestion(q);
    }
  }, [questions]);

  useEffect(() => {
    const questionId = currentQuestion?.questionIds;
    if (!questionId || !quizContentRef.current) return;
    if (questionId === prevQuestionIdRef.current) return;
    prevQuestionIdRef.current = questionId;
    const stored = highlightsRef.current[questionId];
    if (!stored || stored.length === 0) return;
    const timer = setTimeout(() => {
      stored.forEach(text => applyHighlightByText(quizContentRef.current, text, questionId));
    }, 200);
    return () => clearTimeout(timer);
  }, [currentQuestion, applyHighlightByText]);

  // Auto-reveal timer when 5 minutes or less remain
  useEffect(() => {
    if (timeLeft !== null && timeLeft <= 300 && timerHidden) {
      setTimerHidden(false);
    }
  }, [timeLeft, timerHidden]);

  async function getQuestions() {
    var know_sec;
    if (section === 31 || section === 32 || section === 4) {
      know_sec = "Eng"
    }
    else if (section === 11 || section === 12 || section === 2) {
      know_sec = "Math"
    }

    // Capture the IDs to fetch before any state updates so we avoid stale closures
    const questionsToFetch = qarr.length > 0 ? qarr : questionsarr;
    if (qarr.length > 0) { setquestionsarr(qarr); setqarr([]) }

    try {
      setLoadingQuestions(true);
      let res;

      if (id.startsWith('p89_')) {
        res = await axios.get(BASELINE + "questions/sat89", { params: { id: questionsToFetch, section: know_sec } });
      }
      else if (id.startsWith('p10_')) {
        res = await axios.get(BASELINE + "questions/sat10", { params: { id: questionsToFetch, section: know_sec } });
      }
      else {
        res = await axios.get(BASELINE + "questions/sat", { params: { id: questionsToFetch, section: know_sec } });
      }
      let arr = [res.data]
      let mappedQuestions = arr[0].map((question, idx) => {
        return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
      });


      if (qanswers.length > 0) {
        mappedQuestions = mappedQuestions.map((q, idx) => ({
          ...q,
          selectedOption: qanswers[idx] || null,
          bookMarked: qbookmarks[idx] || false,
        }));
        setqanswers([]);
      }
      setQuestions(mappedQuestions);
      setCurrentQuestion(mappedQuestions[loadcurr]);
      setLoadingQuestions(false);
    } catch (err) {
      setLoadingQuestions(false);
      toast.error(err.message);
      setError(err.message)
    }
  }

  async function handleSubmit() {
    if (section === 4) {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        let correctAnswer = question.correct_answer[2].toLowerCase();

        if (question.selectedOption === correctAnswer) {
          obtainedMarks++;

          question.correct = true;
        } else {
          question.correct = false;
        }

        const bookMarked = question.bookMarked;

        if (id.startsWith('p10_')) {
          return {
            section: "1Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT10',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else if (id.startsWith('p89_')) {
          return {
            section: "1Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT89',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else {
          return {
            section: "1Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        }

      });
      setanswers(newDat);
      setbreaks(false);

      if (obtainedMarks >= 17) {
        setsection(32) //harder
      } else {
        setsection(31) //easy
      }

      setloadcurr(0);
      return;
    }
    if (section === 31 || section === 32) {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        let correctAnswer = question.correct_answer[2].toLowerCase();
        if (question.selectedOption === correctAnswer) {
          obtainedMarks++;

          question.correct = true;
        } else {
          question.correct = false;
        }
        let sectionName = section === 31 ? '2Easy' : '2Hard';
        const bookMarked = question.bookMarked;
        if (id.startsWith('p10_')) {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT10',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else if (id.startsWith('p89_')) {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT89',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: correctAnswer,
            questionIds: question.questionIds,
            tag: 'eng',
            topic: question.skill_descs,
            type: 'SAT',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        }
      });

      setanswers(prevAnswers => ([
        ...prevAnswers,
        ...newDat
      ]));

      setbreaks(false);

      setsection(2);
      setloadcurr(0);
      return;
    }
    if (section === 2) {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        var correctAnswer;

        if (question.correct_answer) {
          // Parse the string into a JSON array
          correctAnswer = JSON.parse(question.correct_answer);

          // If there's only one element, convert it to lowercase
          if (correctAnswer.length === 1) {
            correctAnswer = [correctAnswer[0].toLowerCase()];
          }
        } else {
          correctAnswer = ["No Answer"];
        }

        let isCorrect = false;
        if (Array.isArray(correctAnswer)) {
          for (let i = 0; i < correctAnswer.length; i++) {
            if (String(question.selectedOption).trim() === String(correctAnswer[i]).trim()) {
              isCorrect = true;
              break;
            }
          }
        } else {
          isCorrect = question.selectedOption === correctAnswer;
        }

        if (isCorrect) {
          obtainedMarks++;
          question.correct = true;
        } else {
          question.correct = false;
        }
        const bookMarked = question.bookMarked;
        if (id.startsWith('p10_')) {
          return {
            section: "3Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT10',
            bookMarked: bookMarked,
            difficultys: question.difficultys
          }
        } else if (id.startsWith('p89_')) {
          return {
            section: "3Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT89',
            bookMarked: bookMarked,
            difficultys: question.difficultys
          }
        } else {
          return {
            section: "3Hard",
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT',
            bookMarked: bookMarked,
            difficultys: question.difficultys
          }
        }
      });

      setanswers(prevAnswers => ([
        ...prevAnswers,
        ...newDat
      ]));

      setbreaks(false);

      if (obtainedMarks >= 12) {
        setsection(12) //harder
      } else {
        setsection(11) //easy
      }
      setloadcurr(0);
      return;
    }


    try {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        var correctAnswer;

        if (question.correct_answer) {
          // Parse the string into a JSON array
          correctAnswer = JSON.parse(question.correct_answer);

          // If there's only one element, convert it to lowercase
          if (correctAnswer.length === 1) {
            correctAnswer = [correctAnswer[0].toLowerCase()];
          }
        } else {
          correctAnswer = ["No Answer"];
        }

        let isCorrect = false;
        if (Array.isArray(correctAnswer)) {
          for (let i = 0; i < correctAnswer.length; i++) {

            //  question.selectedOption = getRandomChoice(); //this remove

            if (String(question.selectedOption).trim() === String(correctAnswer[i]).trim()) {
              isCorrect = true;
              break;
            }
          }
        } else {
          isCorrect = question.selectedOption === correctAnswer;
        }

        if (isCorrect) {
          obtainedMarks++;
          question.correct = true;
        } else {
          question.correct = false;
        }

        let sectionName = section === 11 ? '4Easy' : '4Hard';
        const bookMarked = question.bookMarked; // Get a random true or false

        if (id.startsWith('p10_')) {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT10',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else if (id.startsWith('p89_')) {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT89',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        } else {
          return {
            section: sectionName,
            correct: question.correct,
            selectedOption: question.selectedOption,
            correct_answer: question.correct_answer,
            questionIds: question.questionIds,
            tag: 'math',
            topic: question.skill_descs,
            type: 'SAT',
            bookmark: bookMarked,
            difficultys: question.difficultys
          }
        }
      });

      let updatedAnswers = [
        ...answers,
        ...newDat
      ];

      setanswers(updatedAnswers);
      const first54Answers = updatedAnswers.slice(0, 54);
      const lastElement = first54Answers[first54Answers.length - 1];

      let engscore = null;
      if (lastElement) {
        const section = lastElement.section;
        const correctCount = first54Answers.filter(answer => answer.correct).length;
        const scoreItem = satScoringTable[correctCount];
        engscore = section === '2Easy' ? scoreItem.Eng[0] : scoreItem.Eng[1];
      }

      const restOfAnswers = updatedAnswers.slice(54);
      const lastElement2 = restOfAnswers[restOfAnswers.length - 1];
      let mathscore = null;
      if (lastElement2) {
        const section = lastElement2.section;
        const correctCount = restOfAnswers.filter(answer => answer.correct).length;
        const scoreItem = satScoringTable[correctCount];
        mathscore = section === '1Easy' ? scoreItem.math[0] : scoreItem.math[1];
      }

      // Assuming SAT_scores is populated appropriately:
      const correctQuestions = updatedAnswers.filter(question => question.correct === true);
      const incorrectQuestions = updatedAnswers.filter(question => question.correct === false);
      const bookmarkedQuestions = updatedAnswers.filter(question => question.bookmark === true); // Assuming 'bookMarked' exists
      const nullCorrectAnswerQuestions = updatedAnswers.filter(question => question.selectedOption === null);

      let data;

      if (!responseData) {
        if (user) {
          if (id.startsWith('p10_')) {
            data = {
              SAT_scores: updatedAnswers,
              userId: user.u_id,
              username: user.first_name + " " + user.last_name,
              test_name: "SAT10 " + id,
              test_id: test_id,
              eng_score: engscore,
              math_score: mathscore,
              usertime: timeSpentRef.current,
              opthistory: userResponses,
              type: 'SAT10',
              correctQuestions: correctQuestions,
              incorrectQuestions: incorrectQuestions,
              bookmarkedQuestions: bookmarkedQuestions,
              nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
            }
          } else if (id.startsWith('p89_')) {
            data = {
              SAT_scores: updatedAnswers,
              userId: user.u_id,
              username: user.first_name + " " + user.last_name,
              test_name: "SAT89 " + id,
              test_id: test_id,
              eng_score: engscore,
              math_score: mathscore,
              usertime: timeSpentRef.current,
              opthistory: userResponses,
              type: 'SAT89',
              correctQuestions: correctQuestions,
              incorrectQuestions: incorrectQuestions,
              bookmarkedQuestions: bookmarkedQuestions,
              nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
            }
          } else {
            data = {
              SAT_scores: updatedAnswers,
              userId: user.u_id,
              username: user.first_name + " " + user.last_name,
              test_name: "SAT " + id,
              test_id: test_id,
              eng_score: engscore,
              math_score: mathscore,
              usertime: timeSpentRef.current,
              opthistory: userResponses,
              type: 'SAT',
              correctQuestions: correctQuestions,
              incorrectQuestions: incorrectQuestions,
              bookmarkedQuestions: bookmarkedQuestions,
              nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
            }
          }
        } else {
          data = {
            SAT_scores: updatedAnswers,
            userId: "Free User",
            username: "Free User",
            test_name: "Free SAT",
            test_id: test_id,
            eng_score: engscore,
            math_score: mathscore,
            usertime: timeSpentRef.current,
            opthistory: userResponses,
            type: 'SAT',
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        }
      } else {
        if (id.startsWith('p10_')) {
          data = {
            SAT_scores: updatedAnswers,
            userId: user.u_id,
            username: user.first_name + " " + user.last_name,
            test_name: "CustomRandom_SAT10",
            test_id: test_id,
            eng_score: engscore,
            math_score: mathscore,
            usertime: timeSpentRef.current,
            opthistory: userResponses,
            type: 'SAT10',
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        } else if (id.startsWith('p89_')) {
          data = {
            SAT_scores: updatedAnswers,
            userId: user.u_id,
            username: user.first_name + " " + user.last_name,
            test_name: "CustomRandom_SAT89",
            test_id: test_id,
            eng_score: engscore,
            math_score: mathscore,
            usertime: timeSpentRef.current,
            opthistory: userResponses,
            type: 'SAT89',
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        }
        else {
          data = {
            SAT_scores: updatedAnswers,
            userId: user.u_id,
            username: user.first_name + " " + user.last_name,
            test_name: "CustomRandom_SAT",
            test_id: test_id,
            eng_score: engscore,
            math_score: mathscore,
            usertime: timeSpentRef.current,
            opthistory: userResponses,
            type: 'SAT',
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        }
      }

      try {
        let saveResult = await axios.post(BASELINE + "tests", data);
        navigate(`/results/presat/${saveResult.data.testId}`);
      } catch (err) {
        console.error("Error saving test results:", err);
        // Handle error (e.g., show a notification)
      }


    } catch (err) {
      toast.error(err.message);
      setError(err.message);
    }
  }

  const handleBookMark = (itemId) => {
    setQuestions((pre => {
      return pre.map((question) => {
        if (question?.questionIds === itemId) {
          if (question.bookMarked) {
            return { ...question, bookMarked: false };
          } else {
            return { ...question, bookMarked: true };
          }
        } else {
          return question;
        }
      })
    }))
  }

  function updateQuestionsAfterInteraction(itemId, selectedOption) {
    setQuestions(prev => {
      const updatedQuestions = prev.map(question => {
        if (question.questionIds === itemId) {
          return {
            ...question,
            selectedOption: selectedOption ? selectedOption : question.selectedOption,
          };
        }
        return question;
      });
      const updatedQuestion = updatedQuestions.find(question => question.questionIds === itemId);
      setCurrentQuestion(updatedQuestion);
      return updatedQuestions;
    });
  }

  async function handleSelectOption(itemId, option) {
    setUserResponses(prev => {
      const currentActions = prev[itemId] ? [...prev[itemId].actions] : [];
      currentActions.push({ action: "mark", option: option });

      return {
        ...prev,
        [itemId]: {
          ...prev[itemId],
          actions: currentActions,
        }
      };
    });

    setQuestions((pre) => {
      const updatedQuestions = pre.map((question) => {
        if (question?.questionIds === itemId) {
          return { ...question, selectedOption: option };
        } else {
          return question;
        }
      });

      // Find the updated question
      const updatedQuestion = updatedQuestions.find((question) => question.questionIds === itemId);

      // Update the currentQuestion state
      setCurrentQuestion(updatedQuestion);
      updateQuestionsAfterInteraction(itemId, option);

      return updatedQuestions;
    });
  }

  async function handleCrossOutOptions(itemId, option) {
    setUserResponses(prev => {
      const currentActions = prev[itemId] ? [...prev[itemId].actions] : [];
      if (prev[itemId] && prev[itemId].actions.some(act => act.action === "crossout" && act.option === option)) {
        // Remove the crossout action if it exists
        return {
          ...prev,
          [itemId]: {
            ...prev[itemId],
            actions: currentActions.filter(act => !(act.action === "crossout" && act.option === option)),
          }
        };
      } else {
        // Add a new crossout action
        currentActions.push({ action: "crossout", option: option });
        return {
          ...prev,
          [itemId]: {
            ...prev[itemId],
            actions: currentActions,
          }
        };
      }
    });
    updateQuestionsAfterInteraction(itemId, null);  // No selection change, just update for crossout.

    setQuestions((pre => {
      return pre.map((question) => {
        if (question?.questionIds === itemId) {
          let crossedOutOptions = question.crossedOutOptions;
          if (crossedOutOptions.includes(option)) {
            crossedOutOptions = crossedOutOptions.filter((el) => el !== option);
          } else {
            crossedOutOptions.push(option);
          }
          return { ...question, crossedOutOptions: crossedOutOptions };
        } else {
          return question;
        }
      })
    }))
  }

  function handleAnswerValueChange(itemId, newValue, result) {
    // 1) 만약 result가 true/false이면 더 이상 입력값을 반영하지 않음
    if (result === true || result === false) {
      return;
    }

    // 2) 허용 문자만 남긴다. (마이너스-, 숫자, 점., 슬래시/ 허용)
    const cleanedValue = newValue.replace(/[^-0-9./]/g, "");

    setQuestions((prevQuestions) => {
      // 3) prevQuestions에서 해당 itemId를 가진 question을 찾는다.
      const questionIndex = prevQuestions.findIndex(
        (q) => q.questionIds === itemId
      );
      if (questionIndex === -1) {
        // 해당 question이 없으면 그냥 반환(에러처리 or 로그)
        console.warn(`Question with id=${itemId} not found.`);
        return prevQuestions;
      }

      // 4) 이미 같은 값이면 굳이 업데이트할 필요 없음 -> state 변경 최소화
      const targetQuestion = prevQuestions[questionIndex];
      if (targetQuestion.selectedOption === cleanedValue) {
        return prevQuestions; // 변경 사항 없으면 기존 배열 그대로 리턴
      }

      // 5) 변경 사항 적용
      const updatedQuestion = {
        ...targetQuestion,
        selectedOption: cleanedValue,
      };

      // 6) 새 배열을 만들어 리턴
      const newQuestions = [...prevQuestions];
      newQuestions[questionIndex] = updatedQuestion;
      
      // 7) Update currentQuestion if it's the one being modified
      if (currentQuestion && currentQuestion.questionIds === itemId) {
        setCurrentQuestion(updatedQuestion);
      }
      
      return newQuestions;
    });
  }

  async function handleNext() {
    if (currentQuestion.index < questions[questions.length - 1].index) {
      setCurrentQuestion((pre) => questions[pre.index + 1])
    } else {
      setCurrentQuestion(null);
      setQuestionOverviewOpen(false);
    }
  }

  async function handleBack() {
    if (!currentQuestion) {
      setCurrentQuestion(questions[questions.length - 1]);
      return;
    }
    if (currentQuestion.index > 0) {
      setCurrentQuestion((pre) => questions[pre.index - 1])
    } else {

    }
  }

  const closeRefModal = () => {
    setShowDirectionRefModal(false);
  };

  const closeModal = () => {
    setShowDirectionModal(false);
  };

  const getSectionDisplay = (section) => {
    switch (section) {
      case 4:
        return 1;
      case 31:
      case 32:
        return 2;
      case 2:
        return 3;
      case 11:
      case 12:
        return 4;
      default:
        return section;
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-white">
      {loadingQuestions ?
        <div className="flex flex-col justify-center items-center py-48">
          <div className="border-t-transparent border-solid animate-spin rounded-full border-blue-400 border-8 h-52 w-52"></div>
          <div className="absolute mt-[-50px]">
            {breaks === true ? <Timer
              minutes={displayMinutes.toString().padStart(2, '0')}
              seconds={displaySeconds.toString().padStart(2, '0')} /> : null}
          </div>
          {breaks === true ?
            <motion.button whileTap={{ scale: 0.97 }} className="py-2 px-5 bg-blue-700 rounded-3xl text-white hover:bg-blue-800 mt-5" onClick={() => { setTimeLeft(-1); }}>
              <Timer
                minutes={displayMinutes.toString().padStart(2, '0')}
                seconds={displaySeconds.toString().padStart(2, '0')} />
              Resume the test
            </motion.button>
            : null}
        </div>
        :
        <>
          <div className="flex flex-row justify-between">

            <div className="bg-gradient-to-r from-[#0d0f1a] via-[#161928] to-[#0d0f1a] border-b border-white/[0.08] flex flex-row justify-between items-center w-full py-2.5 shadow-lg shadow-black/40">
              <div className="ml-4 flex flex-col gap-0.5 min-w-0">
                <span className="hidden md:block text-[11px] font-semibold text-white/40 uppercase tracking-widest">
                  {section === 4 || section === 31 || section === 32 ? "Reading & Writing" : "Math"}
                </span>
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  onClick={() => setShowDirectionModal((pre) => !pre)}
                  className="flex items-center gap-1.5 text-white/70 hover:text-white transition-colors duration-200 text-sm font-medium"
                >
                  <BiSolidDirections className="text-blue-400/80 text-base" />
                  <span className="hidden md:inline">Directions</span>
                  {showDirectionModal ? <BsChevronUp className="text-xs opacity-50" /> : <BsChevronDown className="text-xs opacity-50" />}
                </motion.button>
                {showDirectionModal && <DirectionModal onClose={closeModal} mode={sat} />}
              </div>

              <div className="text-white flex flex-row items-center justify-center flex-grow">
                <div className="flex items-center gap-2 bg-white/[0.06] border border-white/10 rounded-full px-4 py-1.5 backdrop-blur-sm">
                  {timerHidden ? (
                    <span className="font-mono text-sm font-semibold text-white/30 tracking-widest">--:--</span>
                  ) : (
                    <Timer
                      minutes={displayMinutes.toString().padStart(2, '0')}
                      seconds={displaySeconds.toString().padStart(2, '0')}
                    />
                  )}
                  <button
                    onClick={() => setTimerHidden(h => !h)}
                    className="text-white/35 hover:text-white/70 transition-colors ml-0.5"
                    title={timerHidden ? 'Show timer' : 'Hide timer'}
                  >
                    {timerHidden ? <BsEye size="0.85em" /> : <BsEyeSlash size="0.85em" />}
                  </button>
                  <span className="text-white/20">|</span>
                  <span className="text-xs text-white/60 font-medium">Section {getSectionDisplay(section)}</span>
                </div>
              </div>

              {sat === "Math" && (<>
                <motion.button whileTap={{ scale: 0.97 }} onClick={() => setShowCalculator(pre => !pre)} className={`mr-1 flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg cursor-pointer transition-all duration-200 ${showCalculator ? "bg-white/15 text-white" : "text-white/60 hover:text-white hover:bg-white/10"}`}>
                  <div className={`flex flex-row justify-center`}>
                    <CiCalculator1 size="1.5em" />
                  </div>
                  <div>
                    <span className="text-[10px] font-medium hidden md:block">Calculator</span>
                  </div>
                </motion.button>
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  className={`hidden md:flex mr-1 flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg cursor-pointer transition-all duration-200 ${showReference === true ? "bg-white/15 text-white" : "text-white/60 hover:text-white hover:bg-white/10"}`}
                  onClick={() => setShowDirectionRefModal(!showDirectionModalRef)}
                >
                  <div className="flex flex-row justify-center">
                    <VscReferences size="1.5em" />
                  </div>
                  <div>
                    <p className="text-[10px] font-medium">Reference</p>
                  </div>
                </motion.button>
                {showDirectionModalRef && <ReferenceSheet onClose={closeRefModal} />}

                {showCalculator && (
                  <div
                    ref={constraintsRef} // 드래그 제한을 위한 컨테이너
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      zIndex: 100,
                      pointerEvents: "none" // 컨테이너는 클릭 이벤트를 무시
                    }}
                  >
                    <motion.div
                      drag
                      dragConstraints={constraintsRef} // 부모 컨테이너로 제한
                      style={{
                        width: "600px",
                        height: "400px",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "auto", // 실제 계산기는 클릭 가능
                        background: "white",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.3)"
                      }}
                    >
                      <div id="calculator" className="w-full h-full" />
                    </motion.div>
                  </div>
                )}

              </>)}

              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setShowNotePanel(p => !p)}
                className={`mr-1 flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg cursor-pointer transition-all duration-200 ${showNotePanel ? "bg-amber-400/20 text-amber-300" : "text-white/60 hover:text-white hover:bg-white/10"}`}
                title="Notes (session only)"
              >
                <BsJournalText size="1.4em" />
                <span className="text-[10px] font-medium hidden md:block">
                  Notes
                  {currentQuestion && notes[currentQuestion.questionIds] ? <span className="ml-1 text-amber-400">●</span> : null}
                </span>
              </motion.button>

              <div className="mr-4 relative flex flex-col items-center">
                <button
                  onClick={() => setShowOptions(!showOptions)}
                  className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg transition-all duration-200 ${showOptions ? 'bg-white/15 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                >
                  <BsThreeDotsVertical size="1.2em" />
                  <span className="text-[10px] font-medium hidden md:block">More</span>
                </button>

                {showOptions && (
                  <div className="absolute top-[calc(100%+8px)] right-0 z-[20] overflow-hidden bg-black/90 backdrop-blur-2xl border border-white/10 rounded-2xl shadow-2xl shadow-black/50 p-2 flex flex-col gap-1 min-w-[130px]">
                    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent pointer-events-none" />
                    <button
                      onClick={toggleHighlightMode}
                      className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${highlightMode ? 'bg-yellow-400/20 border border-yellow-400/30 text-yellow-300' : 'text-white/60 hover:text-white hover:bg-white/[0.08]'}`}
                    >
                      <BsPencilFill className="text-xs" />
                      <span>Highlight</span>
                      {highlightMode && <span className="ml-auto text-[10px] bg-yellow-400/30 text-yellow-300 px-1.5 py-0.5 rounded-full">ON</span>}
                    </button>
                    <button
                      onClick={() => currentQuestion && handleReportClick()}
                      disabled={!currentQuestion}
                      className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${currentQuestion ? 'text-white/60 hover:text-rose-300 hover:bg-rose-500/10' : 'text-white/20 cursor-not-allowed'}`}
                    >
                      <BsExclamationTriangle className="text-xs" />
                      <span>Report</span>
                    </button>
                    <button
                      onClick={() => { localStorage.setItem("dashboard", "3"); navigate("/main"); }}
                      className="flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium text-white/60 hover:text-blue-300 hover:bg-blue-500/10 transition-all duration-200"
                    >
                      <MdDashboard className="text-xs" />
                      <span>Dashboard</span>
                    </button>
                    {user && user?.role === "teacher" && (
                      <button
                        onClick={() => setshowanswer(!showanswer)}
                        className="flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium text-white/60 hover:text-blue-300 hover:bg-blue-500/10 transition-all duration-200"
                      >
                        <FaKey className="text-xs" />
                        <span>Answer Key</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-row gap-2">

              <div className="flex flex-col cursor-pointer">
                {showModal && (
                  <div className="fixed z-[20] inset-0 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                      </div>
                      <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                      <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                          <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                Report Card
                              </h3>
                              <div className="mt-2">
                                <form>
                                  <label>Question ID:</label>
                                  <input type="text" className="border p-1 mt-1 w-full" value={currentQuestion.questionIds} readOnly />
                                  <label>Report from:</label>
                                  <input type="text" className="border p-1 mt-1 w-full" value={user?.first_name + " " + user?.last_name} readOnly />
                                  <label>Context:</label>
                                  <textarea
                                    className="border p-1 mt-1 w-full"
                                    value={context}
                                    onChange={handleContextChange}
                                  />
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={handleSubmit2}
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                            onClick={handleCloseModal}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>

          <div className="flex-1 overflow-y-auto scrollbar-hide">
            {loadingQuestions ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : (
              currentQuestion ? (
                <div ref={quizContentRef} className="px-4 pt-4" onMouseUp={handleMouseUp} style={highlightMode ? { cursor: 'text', userSelect: 'text' } : {}}>
                  <Question
                    sat={sat}
                    handleAnswerValueChange={handleAnswerValueChange}
                    handleCrossOutOptions={handleCrossOutOptions}
                    handleSelectOption={handleSelectOption}
                    currentQuestion={currentQuestion}
                    idx={1}
                    bookmarkedQuestions={bookmarkedQuestions}
                    setBookMarkedQuestions={setBookMarkedQuestions}
                    handleBookMark={handleBookMark}
                  />
                </div>
              ) : (
                <Review
                  currentQuestion={currentQuestion}
                  setCurrentQuestion={setCurrentQuestion}
                  questions={questions}
                  setQuestions={setQuestions}
                  timeSpent={timeSpentRef.current}
                />
              )
            )}
          </div>

          <div className="hidden md:flex z-[300] fixed inset-x-0 flex-row justify-around bg-gradient-to-r from-[#0d0f1a] via-[#161928] to-[#0d0f1a] border-t border-white/[0.08] py-2.5 bottom-0 shadow-[0_-4px_24px_rgba(0,0,0,0.5)]">
            {questionOverViewOpen && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.18, ease: 'easeOut' }}
                className="fixed z-[9999] w-[400px] rounded-2xl shadow-2xl border border-gray-700"
                style={{ bottom: '68px', left: 'calc(50vw - 200px)', backgroundColor: '#111827' }}
              >
                {/* Header */}
                <div className="px-4 pt-4 pb-3" style={{ borderBottom: '1px solid #374151' }}>
                  <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
                    Question Overview
                  </p>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <div className="w-2.5 h-2.5 rounded-full bg-blue-500" style={{ flexShrink: 0 }} />
                      <span className="text-xs text-gray-300 font-medium">
                        {questions.filter(q => q.selectedOption != null).length} Answered
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-2.5 h-2.5 rounded-full bg-rose-500" style={{ flexShrink: 0 }} />
                      <span className="text-xs text-gray-300 font-medium">
                        {questions.filter(q => q.bookMarked).length} Marked
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-2.5 h-2.5 rounded-full bg-gray-600" style={{ flexShrink: 0 }} />
                      <span className="text-xs text-gray-400 font-medium">
                        {questions.filter(q => q.selectedOption == null && !q.bookMarked).length} Unanswered
                      </span>
                    </div>
                  </div>
                </div>

                {/* Question grid */}
                <div className="p-3" style={{ maxHeight: '160px', overflowY: 'auto' }}>
                  <div className="flex flex-wrap gap-1.5">
                    {questions.map((ques, idx) => {
                      const isCurrent = currentQuestion?.questionIds === ques?.questionIds;
                      const isBookmarked = ques.bookMarked;
                      const isAnswered = ques.selectedOption != null;
                      let bg, border, color;
                      if (isBookmarked) {
                        bg = '#dc2626'; border = '#ef4444'; color = '#fff';
                      } else if (isCurrent) {
                        bg = '#ffffff'; border = '#ffffff'; color = '#111827';
                      } else if (isAnswered) {
                        bg = '#2563eb'; border = '#3b82f6'; color = '#fff';
                      } else {
                        bg = '#1f2937'; border = '#374151'; color = '#9ca3af';
                      }
                      return (
                        <button
                          key={'questions-' + idx}
                          onClick={() => setCurrentQuestion(questions[idx])}
                          style={{ backgroundColor: bg, borderColor: border, color, width: '36px', height: '36px', borderWidth: '1px', borderStyle: 'solid', borderRadius: '8px', fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'transform 0.1s', flexShrink: 0 }}
                          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
                          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                        >
                          {idx + 1}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </motion.div>
            )}

            <div className="hidden md:flex items-center">
              <p className="text-white/70 font-medium text-sm">
                {free ? 'Free Trial' : `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim() || 'John Doe'}
              </p>
            </div>

            {currentQuestion && (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setQuestionOverviewOpen((pre) => !pre)}
                className="flex flex-row items-center gap-1.5 bg-white/[0.08] hover:bg-white/[0.14] border border-white/15 text-white/80 hover:text-white rounded-xl px-3 py-2 cursor-pointer transition-all duration-200 text-sm font-medium"
              >
                <div className="flex flex-row items-center">
                  <p className="text-sm">
                    Question {currentQuestion?.index + 1} of {questions?.length}
                  </p>
                </div>
                <div className="flex flex-row items-center">
                  {questionOverViewOpen ? <BsChevronDown /> : <BsChevronUp />}
                </div>
              </motion.button>
            )}

            <div className="items-center pb-2">
              <motion.button
                whileTap={{ scale: 0.97 }}
                className="py-2 px-5 bg-white/[0.08] hover:bg-white/[0.15] border border-white/15 text-white/80 hover:text-white rounded-xl text-sm font-medium transition-all duration-200"
                onClick={() => handleBack()}
              >
                Back
              </motion.button>
              {currentQuestion ? (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  className="ml-2 py-2 px-5 bg-blue-500/70 hover:bg-blue-500 border border-blue-400/40 text-white rounded-xl text-sm font-medium transition-all duration-200 shadow-sm shadow-blue-500/20"
                  onClick={() => { handleNext(); setShowOptions(false) }}
                >
                  Next
                </motion.button>
              ) : (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  className="ml-2 py-2 px-5 bg-blue-500/70 hover:bg-blue-500 border border-blue-400/40 text-white rounded-xl text-sm font-medium transition-all duration-200 shadow-sm shadow-blue-500/20"
                  onClick={() => setShowSubmitConfirm(true)}
                >
                  Submit
                </motion.button>
              )}
            </div>
          </div>

          {/**Mobile */}
          <div className="flex md:hidden justify-between items-center px-4 py-3 bg-[#1a1a1a] text-white rounded-full mb-2 mx-[40px] relative">
            {questionOverViewOpen && (
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  type: "spring",
                }}
                className="text-black absolute mb-[230px] z-[3000] rounded-md flex flex-row justify-center p-1 bg-white border-[1px] border-gray-300"
              >
                <div className="bg-white min-h-[140px] max-h-[140px] flex flex-row flex-wrap rounded-md">
                  {questions.map((ques, idx) => (
                    <div
                      key={'questions-' + idx}
                      onClick={() => setCurrentQuestion(questions[idx])}
                      className={`${ques.bookMarked && 'bg-red-500 border-none text-white'} 
            m-1 rounded-full border-[1px] w-[25px] h-[25px] flex flex-row justify-center items-center cursor-pointer 
            ${currentQuestion?.questionIds === ques?.questionIds && 'bg-black text-white'}
            ${ques.selectedOption != null && 'border-none bg-blue-700 text-white'}
            border-black`}
                    >
                      {idx + 1}
                    </div>
                  ))}
                </div>
              </motion.div>
            )}

            <motion.button
              whileTap={{ scale: 0.97 }}
              onClick={handleBack}
              className="text-[24px]"
            >
              &lt;
            </motion.button>

            {currentQuestion && (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setQuestionOverviewOpen((pre) => !pre)}
                className="flex flex-row items-center gap-1 bg-white hover:bg-gray-200 text-[#1a1a1a] rounded-md p-2 cursor-pointer"
              >
                <div className="flex flex-row items-center">
                  <p className="text-sm">
                    Question {currentQuestion?.index + 1} of {questions?.length}
                  </p>
                </div>
                <div className="flex flex-row items-center">
                  {questionOverViewOpen ? <BsChevronDown /> : <BsChevronUp />}
                </div>
              </motion.button>
            )}
            {currentQuestion ? (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={handleNext}
                className="text-[24px]"
              >
                &gt;
              </motion.button>
            ) : (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setShowSubmitConfirm(true)}
                className="text-[24px]"
              >
                &gt;
              </motion.button>
            )}

          </div>

        </>
      }
      {/* Note Panel */}
      {showNotePanel && (
        <div className="fixed top-[52px] right-0 bottom-[56px] w-72 z-[150] flex flex-col border-l border-white/10 shadow-2xl shadow-black/50"
          style={{ background: '#0e1020' }}
        >
          <div className="px-4 pt-4 pb-3 border-b border-white/[0.08]">
            <div className="flex items-center justify-between mb-3">
              <span className="text-white/80 font-semibold text-sm">Notes</span>
              <button onClick={() => setShowNotePanel(false)} className="text-white/40 hover:text-white/80 transition-colors text-lg leading-none">✕</button>
            </div>
            <div className="flex items-start gap-2 rounded-xl px-3 py-2.5 border border-amber-400/25" style={{ background: 'rgba(245,158,11,0.08)' }}>
              <svg className="w-3.5 h-3.5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <p className="text-amber-300/80 text-[11px] leading-relaxed">
                Notes are <span className="font-bold text-amber-300">not saved</span>. They will be permanently lost when you refresh or close this page.
              </p>
            </div>
          </div>
          <div className="flex-1 p-4 flex flex-col">
            <p className="text-white/30 text-[11px] mb-2 uppercase tracking-wider">
              {currentQuestion ? `Question ${currentQuestion.index + 1}` : 'No question selected'}
            </p>
            <textarea
              className="flex-1 w-full bg-white/[0.04] border border-white/[0.08] rounded-xl text-white/75 text-sm p-3 resize-none focus:outline-none focus:border-white/20 placeholder-white/20"
              placeholder={currentQuestion ? "Write your note here..." : "Select a question to add a note."}
              disabled={!currentQuestion}
              value={currentQuestion ? (notes[currentQuestion.questionIds] || '') : ''}
              onChange={(e) => {
                if (!currentQuestion) return;
                const qid = currentQuestion.questionIds;
                const val = e.target.value;
                setNotes(prev => ({ ...prev, [qid]: val }));
              }}
            />
          </div>
        </div>
      )}

      {/* Submit Section Confirmation Modal */}
      {showSubmitConfirm && (
        <div className="fixed inset-0 z-[400] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/65 backdrop-blur-sm" onClick={() => setShowSubmitConfirm(false)} />
          <div className="relative rounded-2xl border border-white/10 shadow-2xl shadow-black/60 p-6 w-full max-w-md mx-4"
            style={{ background: '#111320' }}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-xl bg-amber-500/15 border border-amber-400/25 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
              </div>
              <div>
                <h2 className="text-white font-bold text-base">Submit Section {getSectionDisplay(section)}?</h2>
                <p className="text-white/40 text-xs mt-0.5">
                  {section === 12 || section === 11 ? 'This is the final section.' : `Next: Section ${getSectionDisplay(section) + 1}`}
                </p>
              </div>
            </div>
            <p className="text-white/55 text-sm mb-5 leading-relaxed">
              Once you submit this section, you <span className="text-amber-300 font-semibold">cannot return to it</span>. Make sure you have reviewed all your answers before continuing.
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setShowSubmitConfirm(false)}
                className="px-4 py-2 rounded-xl border border-white/[0.12] text-white/60 hover:text-white hover:border-white/25 text-sm font-medium transition-all duration-200"
              >
                Go Back
              </button>
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => { setShowSubmitConfirm(false); handleSubmit(); }}
                className="px-5 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-all duration-200 shadow-lg shadow-blue-600/30"
              >
                Submit Section
              </motion.button>
            </div>
          </div>
        </div>
      )}
    </div >
  );
};
export default PresetSAT;